import { useState } from "react";

import { Input, message } from "antd";

import Loading from "../Shared/Loading";
import loginIcon from "../../assets/images/ERS-logo.png";
import { token } from "../../Utils/SignForm/signIn";
import { setToken } from "../../service/auth.service";

import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setUser } from "../../redux/slices/userSlice";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);


  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const res = await token({ username, password, remember_me: isChecked });
      if (res.status === 200) {
        setToken(res.data?.access_token);
        dispatch(setUser(res.data))
        if (res.data?.user_role.name === "admin" || res.data?.user_role.name === "superadmin") {
          navigate("/admin/map");
        } else if (res.data?.user_role.name === "client") {
          navigate("/client/map");
        } else if (res.data?.user_role.name === "domain_manager") {
          navigate("/domain-manager/map");
        } else if (res.data?.user_role.name === "exploitation_manager") {
          navigate("/exploitation-manager/map");
        } else {
          messageApi.error("Rôle utilisateur non trouvé");
        }
      }
      setLoading(false);
    } catch (error) {
        if (error.response?.status === 400) {
          messageApi.error("Nom d'utilisateur ou mot de passe incorrect");

        } else if (error.response?.status === 404) {
          messageApi.error("Utilisateur non trouvé");
        } else {
          messageApi.error("Une erreur s'est produite. Veuillez réessayer");
        }
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loading />}
      {contextHolder}
    <div className="flex flex-col p-8 items-center h-full w-full">
        <img src={loginIcon} alt="" className="w-3/5" />
        <div className="font-bold text-2xl my-8">
          Se Connecter à votre Compte
        </div>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="flex flex-col w-full gap-5">
            <div>
              <label htmlFor="email" className="font-medium">
                Adresse mail
              </label>
              <Input
                id="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Entrez votre adresse"
                className="input-primary shadow-md text-gray-900 text-sm custom-input rounded-lg py-2.5 mt-2"
                required
              />
            </div>
            <div>
              <label htmlFor="password" className="font-medium">
                Mot de passe
              </label>
              <Input.Password
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Saisissez votre mot de passe"
                className="input-primary shadow-md text-gray-900 text-sm custom-input rounded-lg py-2.5 mt-2"
                required
              />
            </div>
          </div>
          <div className="flex justify-between w-full my-5 gap-3">
            <div className="flex items-center">
              <input
                id="checked-checkbox"
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:border-indigo-600"
              />
              <label
                htmlFor="checked-checkbox"
                className="ms-2 text-sm font-medium text-gray-900"
              >
                Se souvenir de moi
              </label>
            </div>
          </div>
          <button
            type="submit"
            className="w-full text-white  bg-indigo-600 hover:bg-blue-800 font-medium rounded-md text-sm px-5 py-2.5 mb-2 focus:outline-none"
          >
            Se connecter
          </button>
        </form>
        <div className="flex justify-around w-full">
          <span className="text-sm">Des difficultés ?</span>
          <span 
            className="text-indigo-600 text-sm cursor-pointer no-select hover:text-indigo-800"
            onClick={() => navigate('/contact')}
          >
            Contactez nos services
          </span>
        </div>
      </div>
    </>
  );
};

export default SignIn;
